/** In-memory cache for Closed Enrollments pages. Clears on hard refresh. */
const pageCache = new Map();

export const buildClosedEnrollmentCacheKey = ({
  page,
  search = '',
  paymentStatus = 'all',
  limit = 8
}) => `v3|${limit}|${page}|${search}|${paymentStatus}`;

export const getClosedEnrollmentCache = (key) => pageCache.get(key) || null;

export const setClosedEnrollmentCache = (key, value) => {
  pageCache.set(key, value);
};

export const clearClosedEnrollmentCache = () => {
  pageCache.clear();
};
